import { INTERFACE } from '@/utils/INTERFACE';
import http from '@/utils/http';
import {getSystem} from '@/utils/site'
import { getChannelNumber, getSiteNumber } from '@/utils/siteDefs';
import { getCurrency } from '@/utils/currency';
import {SplitQueue} from '@/utils/queue'
import md5 from 'md5'


/**
 * params [{skuId:Number,promoId:Number}]
 * return [
 *  jdPrice:Number,
 *  promoPrice:Number,
 *  numAvailable:Number,
 *  remainNumAvailable:Number,
 *  unit_discount:Number
 * ]
*/
export async function getPromotionState(arr,hidePriceFlag){
    if(!arr||!arr.length){
        return {}
    }
    var sys=getSystem()
    var stateMap={}
    if(sys=='ept'){
        let queue=new SplitQueue(async arr=>{ 
            let res = await http.jsonp.get(INTERFACE().promotionState, { 
                json: JSON.stringify({
                    channel:getChannelNumber(),
                    curList:[getCurrency()],
                    site:getSiteNumber(),
                    ids:arr.map(it=>({
                        promoId:it.promoId,
                        skuIds:[it.skuId]
                    }))
                })
            }) 
            return res
        },20)
        let data=await queue.fetch(arr)
        data.forEach(it => {
            if(it.skuInfos[0]){
                stateMap[it.skuInfos[0].skuId] = {
                    jdPrice:it.skuInfos[0].prices[0].jdPrice,
                    promoPrice:it.skuInfos[0].prices[0].discountPrice,
                    numAvailable:it.skuInfos[0].stock||0,
                    remainNumAvailable:it.skuInfos[0].remainStock||0,
                    unit_discount:it.skuInfos[0].prices[0].discountOff
                }
            }
        })
        return stateMap
    }else{
        let queue=new SplitQueue(async ids=>{ 
            let res = await http.jsonp.get(INTERFACE().promotionState, { 
                promoIds: ids.join(','),
                sysFlag:sys,
                token:md5(ids.join(',')+(hidePriceFlag?"0":"1"))
            }) 
            return res.promotionInfoList 
        },20) 
        let data=await queue.fetch(arr.map(it=>it.promoId))
        data.forEach(it => stateMap[it.skuId] = it) 
        return stateMap
    }
}

export async function getPromotion(arr){
    var sys=getSystem()
    var queue=new SplitQueue(async ids=>{
        let res= await http.get(INTERFACE().promotion, {
            promoGoodsId: ids.join(','),
            sysFlag:sys
        })
        return res.promoGoodList
    },20)
    return await queue.fetch(arr)
}